import React from 'react';
// import ReactDOM from 'react-dom';
import ReactDOM from "react-dom/client";
import './index.css';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import reportWebVitals from "./reportWebVitals";

import ReactGA from "react-ga4";


ReactGA.initialize("G-M225SMDFL8");

// import { useLocation, BrowserRouter as Router, Route, Routes } from 'react-router-dom';
i18n.use(initReactI18next).use(HttpApi).init({
  backend: {
    loadPath: '/locales/{{lng}}.json', // Path to your translation files
  },
  fallbackLng: 'gr',
  lng: 'gr', // Set the default language here
  interpolation: {
    escapeValue: false,
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
  
reportWebVitals();